import { ref, watch, type Ref } from 'vue'
import { notify } from '@staff/ui'
import { fetchInvoicesByUser, fetchInvoiceById, type InvoiceListItem, type InvoiceDetail } from '@/services/invoice'

export const useInvoices = (userId: Ref<string>) => {
  const isLoading = ref(true)
  const invoices = ref<InvoiceListItem[]>([])

  watch(
    userId,
    async (id) => {
      isLoading.value = true
      try {
        invoices.value = await fetchInvoicesByUser(id)
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Kunde inte hämta fakturor'
        notify({ type: 'error', title: message, dismissable: true })
      } finally {
        isLoading.value = false
      }
    },
    { immediate: true },
  )

  const fetchDetail = async (id: string): Promise<InvoiceDetail | null> => {
    try {
      return await fetchInvoiceById(id)
    } catch (err) {
      const message = err instanceof Error ? err.message : `Kunde inte hämta faktura ${id}`
      notify({ type: 'error', title: message, dismissable: true })
      return null
    }
  }

  return { isLoading, invoices, fetchDetail }
}
